import { Component } from '@angular/core';

@Component({
  selector: 'zikatagov-button-group',
  template: `
    <div class="btn-group" role="group">
      <ng-content></ng-content>
    </div>
  `,
  standalone: true,
})
export class ZikataButtonGroupComponent {}
